import { useParams } from "react-router-dom";
import moment from "moment";
import { CircularProgress } from "@mui/material";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import {
  getBillingDetailNew,
  getBillingDetailPbf,
} from "../../../services/billingAPI";
import { STATUS_ONLINE_BILLING } from "../../constants/constant";
import ModalPaymentStatus from "./ModalPaymentStatus";
import ModalCancelPaymentVa from "./ModalCancelPaymentVa";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const OnlineBillingDetail = ({ isPbf }) => {
  const { invNum } = useParams();

  const [openModalPay, setOpenModalPay] = useState(false);
  const [openModalCancelVa, setOpenModalCancelVa] = useState(false);

  const {
    data,
    isFetching: isFetchingData,
    refetch,
  } = useQuery({
    queryKey: ["detail-billing", invNum],
    queryFn: () =>
      isPbf ? getBillingDetailPbf(invNum) : getBillingDetailNew(invNum),
    enabled: invNum !== undefined && invNum !== null,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="text-[12px]">
      <LoadingBackdrop isLoading={false} />

      {/* show reason if status belum dibayar / telat dibayar and has reason */}
      {data &&
      !isFetchingData &&
      [1, 3].includes(data.status) &&
      data.reason &&
      data.reason !== "-" ? (
        <div className="bg-blue-100 mb-4 p-4 rounded-lg">
          <p className="font-bold text-[14px]">
            Pembayaran Transfer Manual Ditolak
          </p>
          <p className="mb-4">Pembayaran anda ditolak karena alasan berikut</p>

          <p>{data.reason}</p>
        </div>
      ) : null}

      <div className="mb-4 grid grid-cols-2 md:grid-cols-6 gap-4 w-full ">
        <div className="w-full">
          <p className="font-bold">Tanggal PO</p>
          {data && !isFetchingData ? (
            <p>{moment(data.po_date).format("DD MMMM YYYY")}</p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        {isPbf ? null : (
          <div className="w-full">
            <p className="font-bold">Nomor PO</p>
            {data && !isFetchingData ? (
              <p>{data.po_number}</p>
            ) : (
              <CircularProgress size={15} />
            )}
          </div>
        )}
        <div className="w-full">
          <p className="font-bold">Tanggal Pembayaran</p>
          {data && !isFetchingData ? (
            <p>
              {moment(isPbf ? data.date_transaction : data.invoice_date).format(
                "DD MMMM YYYY",
              )}
            </p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        <div className="w-full">
          <p className="font-bold">Nomor Invoice</p>
          {data && !isFetchingData ? (
            <p>{isPbf ? data.invoice_no : data.invoice_number}</p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        <div className="w-full">
          <p className="font-bold">Apoteker</p>
          {data && !isFetchingData ? (
            <p>{data.apoteker_name}</p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        <div className="w-full">
          <p className="font-bold">Metode Pembayaran Billing</p>
          {data && !isFetchingData ? (
            <p>
              {isPbf
                ? data.payment?.payment_channel_name
                : data.payment_method
                  ? data.payment_method
                  : ""}
            </p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
      </div>
      <div className="mb-4 grid grid-cols-2 md:grid-cols-6 gap-4 w-full">
        <div className="w-full">
          <p className="font-bold">Total Transaksi</p>
          {data && !isFetchingData ? (
            <p>{toIDR(isPbf ? data.total_bill : data.total_transaction)}</p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        <div className="w-full">
          <p className="font-bold">Jatuh Tempo</p>
          {data && !isFetchingData ? (
            <p>
              {moment(isPbf ? data.date_bill_due : data.due_date).format(
                "DD MMMM YYYY",
              )}
            </p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        <div className="w-full">
          <p className="font-bold">Tempo</p>
          {data && !isFetchingData ? (
            <p>{data.tempo} Hari</p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        {isPbf ? null : (
          <div className="w-full">
            <p className="font-bold">Sumber</p>
            {data && !isFetchingData ? (
              <p>{data.source}</p>
            ) : (
              <CircularProgress size={15} />
            )}
          </div>
        )}
        <div className="w-full">
          <p className="font-bold">Status</p>
          {data && !isFetchingData ? (
            <p
              className={`w-full font-semibold ${
                data.status === 1
                  ? "text-red-500"
                  : data.status === 2
                    ? "text-purple-500"
                    : data.status === 4
                      ? "text-green-500"
                      : data.status === 5
                        ? "text-yellow-500"
                        : "text-black"
              }`}
            >
              {
                STATUS_ONLINE_BILLING.find((item) => item.id === data.status)
                  ?.value
              }
            </p>
          ) : (
            <CircularProgress size={15} />
          )}
        </div>
        <div className="w-full">
          {true ? (
            <button
              type="button"
              className="bg-blue-500 rounded-md text-white hover:bg-gray-300 w-full p-2 disabled:bg-gray-300"
              disabled={
                !data || isFetchingData || ![1, 2, 3].includes(data.status)
              }
              onClick={() => {
                if (data && data.status === 2) setOpenModalCancelVa(true);
                else setOpenModalPay(true);
              }}
            >
              {isFetchingData
                ? "Loading..."
                : data && data.status === 2
                  ? "Batalkan Pembayaran"
                  : "Bayar"}
            </button>
          ) : null}
        </div>
      </div>

      <div className="flex w-full mb-8">
        <div className="w-full">
          <div className="block overflow-x-auto overflow-y-auto max-h-[60vh] md:max-h-[38vh] w-full rounded-md relative">
            <table className="w-full overflow-x-auto rounded-md border-collapse">
              <thead className="bg-blue-500 text-white sticky top-0">
                <th className="p-2 text-center">No</th>
                <th className="p-2 text-center whitespace-nowrap">Produk</th>
                <th className="p-2 text-center whitespace-nowrap">
                  Kuantitas PO
                </th>
                <th className="p-2 text-center whitespace-nowrap min-w-[200px]">
                  HNA Satuan
                </th>
                <th className="p-2 text-center whitespace-nowrap">
                  Diskon (%)
                </th>
                <th className="p-2 text-center whitespace-nowrap">
                  Harga Akhir
                </th>
                <th className="p-2 text-center whitespace-nowrap">Sub Total</th>
              </thead>
              <tbody className="border">
                {data && !isFetchingData && data.products ? (
                  data.products.map((item, i) => (
                    <tr key={i} className={`${i === 0 ? "" : "border-t"}`}>
                      <td className="p-2 text-center whitespace-nowrap">
                        {i + 1}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {isPbf ? item.name : item.product_name}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {isPbf ? item.qty : item.quantity}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {toIDR(isPbf ? item.unit_price : item.hna)}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {isPbf ? item.discount_value : item.discount}%
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {toIDR(
                          isPbf
                            ? (item.unit_price * (100 - item.discount_value)) /
                                100
                            : (item.net_price * (100 - item.discount)) / 100,
                        )}
                      </td>
                      <td className="p-2 text-center whitespace-nowrap">
                        {toIDR(isPbf ? item.line_net : item.subtotal)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="border">
                    <td className="py-2 text-center" colSpan={7}>
                      {isFetchingData ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Tidak ada produk"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="w-full md:flex gap-4">
        {isPbf ? null : (
          <div className="w-full">
            <p className="font-bold text-[14px] mb-2">Info Pengiriman</p>
            <div className="flex gap-2 items-start mb-2">
              <p className="w-1/2 whitespace-nowrap truncate">Kurir</p>
              <p>:</p>
              <p>
                {data && !isFetchingData && !isPbf ? (
                  toIDR(data.shipping.shipping_name)
                ) : isFetchingData ? (
                  <CircularProgress size={20} />
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="flex gap-2 items-start mb-2">
              <p className="w-1/2 whitespace-nowrap truncate">Nomor Resi</p>
              <p>:</p>
              <p>
                {data && !isFetchingData && !isPbf ? (
                  data.shipping.shipping_number
                ) : isFetchingData ? (
                  <CircularProgress size={20} />
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="flex gap-2 items-start mb-2">
              <p className="w-1/2 whitespace-nowrap truncate">Alamat</p>
              <p>:</p>
              <p>
                {data && !isFetchingData && !isPbf ? (
                  data.shipping.shipping_address
                ) : isFetchingData ? (
                  <CircularProgress size={20} />
                ) : (
                  ""
                )}
              </p>
            </div>
          </div>
        )}
        <div className="w-full">
          <p className="font-bold text-[14px] mb-2">Rincian Pembayaran</p>
          <div className="flex gap-2 items-start mb-2">
            <p className="w-1/2 whitespace-nowrap truncate">
              Metode Pembayaran
            </p>
            <p>:</p>
            <p>
              {data && !isFetchingData ? (
                isPbf ? (
                  data.payment?.payment_channel_name
                ) : (
                  data.payment.payment_method
                )
              ) : isFetchingData ? (
                <CircularProgress size={20} />
              ) : (
                ""
              )}
            </p>
          </div>
          <div className="flex gap-2 items-start mb-2">
            <p className="w-1/2 whitespace-nowrap truncate">Subtotal Produk</p>
            <p>:</p>
            <p>
              {data && !isFetchingData ? (
                toIDR(
                  isPbf
                    ? data.payment_summary?.subtotal
                    : data.payment.subtotal,
                )
              ) : isFetchingData ? (
                <CircularProgress size={20} />
              ) : (
                ""
              )}
            </p>
          </div>
          <div className="flex gap-2 items-start mb-2">
            <p className="w-1/2 whitespace-nowrap truncate">Ongkos Kirim</p>
            <p>:</p>
            <p>
              {data && !isFetchingData ? (
                toIDR(
                  isPbf
                    ? data.payment_summary?.shipping_fee
                    : data.payment.shipping_price,
                )
              ) : isFetchingData ? (
                <CircularProgress size={20} />
              ) : (
                ""
              )}
            </p>
          </div>
          <div className="flex gap-2 items-start mb-2">
            <p className="w-1/2 whitespace-nowrap truncate">
              Diskon Ongkos Kirim
            </p>
            <p>:</p>
            <p>
              {data && !isFetchingData ? (
                toIDR(isPbf ? 0 : data.payment?.discount_shipping)
              ) : isFetchingData ? (
                <CircularProgress size={20} />
              ) : (
                ""
              )}
            </p>
          </div>
          <div className="flex gap-2 items-start mb-2">
            <p className="w-1/2 whitespace-nowrap truncate">PPN 11%</p>
            <p>:</p>
            <p>
              {data && !isFetchingData ? (
                toIDR(
                  isPbf ? data.payment_summary?.ppn_amount : data.payment.ppn,
                )
              ) : isFetchingData ? (
                <CircularProgress size={20} />
              ) : (
                ""
              )}
            </p>
          </div>
          {isPbf ? null : (
            <div className="flex gap-2 items-start mb-2">
              <p className="w-1/2 whitespace-nowrap truncate">Olin Point</p>
              <p>:</p>
              <p>
                {data && !isFetchingData ? (
                  toIDR(data.payment.point_used)
                ) : isFetchingData ? (
                  <CircularProgress size={20} />
                ) : (
                  ""
                )}
              </p>
            </div>
          )}
          <div className="flex gap-2 items-center mb-2 bg-blue-100 text-blue-500 p-1 rounded-md font-bold">
            <p className="w-1/2 whitespace-nowrap truncate">Total Pembayaran</p>
            <p>:</p>
            <p>
              {data && !isFetchingData ? (
                toIDR(
                  isPbf
                    ? data.payment_summary?.grand_total
                    : data.payment.total,
                )
              ) : isFetchingData ? (
                <CircularProgress size={20} />
              ) : (
                ""
              )}
            </p>
          </div>
        </div>
      </div>

      {data && !isFetchingData ? (
        <>
          <ModalPaymentStatus
            open={openModalPay}
            setOpen={setOpenModalPay}
            bill={[data]}
            refetchList={() => refetch()}
            isPbf={isPbf}
          />
          <ModalCancelPaymentVa
            open={openModalCancelVa}
            setOpen={setOpenModalCancelVa}
            refetch={() => refetch()}
            dataDetail={data}
            isPbf={isPbf}
          />
        </>
      ) : null}
    </div>
  );
};

export default OnlineBillingDetail;
